export default "__VITE_ASSET__DSn8UuoQ__"